export enum NativePermission {
  Accepted = "permission_granted",
  Denied = "permission_denied",
  PermanentDenied = "permission_permanently_denied",
}
